import { CreateSendPalletDTO, SendPalletAddressDTO } from 'interfaces';

export const parseCreateSendPalletDTOIntoSendPalletAddressDTO: (
   createSendPalletDTO: CreateSendPalletDTO,
) => SendPalletAddressDTO = createSendPalletDTO => {
   const { commercialNetworkName, commercialNetworkAddress } = createSendPalletDTO;
   return { commercialNetworkName, commercialNetworkAddress };
};
